<template><svg viewBox="0 0 20 20" fill="none"><rect x="1" y="1" width="18" height="18" rx="4" stroke="#64747F" stroke-width="1.5"/></svg></template>